import { toast as sonnerToast } from "sonner";

export type ToastProps = {
  title?: string;
  description?: string;
  type?: "success" | "info" | "warning" | "error" | "default";
  variant?: "default" | "destructive";
  duration?: number;
  action?: React.ReactNode;
};

// Custom hook to provide toast functionality
export const useToast = () => {
  return {
    toast: (props: ToastProps) => toast(props),
    toasts: [] // Empty array to satisfy the interface
  };
};

export function toast({
  title,
  description,
  type = "default",
  variant,
  duration,
  action,
}: ToastProps) {
  // Map the "type" prop to sonner's compatible property
  let toastType: any; // Using any to avoid type issues for now
  
  // If variant is provided, use it directly
  if (variant) {
    toastType = variant;
  } else {
    // Otherwise, map type to an appropriate variant
    switch (type) {
      case "success":
        toastType = "success";
        break;
      case "error":
        toastType = "destructive";
        break;
      case "warning":
        toastType = "warning";
        break;
      case "info":
        toastType = "info";
        break;
      default:
        toastType = "default";
    }
  }

  return sonnerToast(title, {
    description,
    duration,
    action,
    // Use as any to bypass type checking since Sonner's types have changed
    ...(toastType ? { variant: toastType as any } : {})
  });
}
